<ion-row class="filter-row">
  <ion-col size="11">
    @if (!isTradingVolumeSelected) {
      <span class="subtitle">{{ 'insights.subtitle-number-of-trades' | translate }}</span>
    }
    @else {
      <span class="subtitle">{{ 'insights.subtitle-volume' | translate }}</span>
    }
  </ion-col>
  <ion-col size="1">
    <ion-icon src="assets/icon/icon_filter.svg"
              class="icon-filter"
              (click)="openFilters()" />
  </ion-col>
</ion-row>
